import { useEffect } from "react";
import { useSearch } from "wouter";

const INTENT_PARAM = "addInstallation";

export function createdContractPath(customerId: number, contractId: number, addInstallation = false): string {
  const path = `/customers/${customerId}/contracts/${contractId}`;
  return addInstallation ? `${path}?tab=instalaciones&${INTENT_PARAM}=1` : path;
}

export interface InstallationIntentState {
  routeCustomerId: number | null;
  routeContractId: number | null;
  contract?: { id: number; customerPartnerId: number } | null;
  canLinkInstallations?: boolean;
  failed: boolean;
}

// Fail closed: an intent never authorizes a write. The existing dialog and
// server mutation remain the only installation-creation path.
export function installationIntentDecision(state: InstallationIntentState): "wait" | "discard" | "open" {
  const { routeCustomerId, routeContractId, contract, canLinkInstallations, failed } = state;
  if (!Number.isSafeInteger(routeCustomerId) || !Number.isSafeInteger(routeContractId) ||
      (routeCustomerId ?? 0) <= 0 || (routeContractId ?? 0) <= 0 || failed) return "discard";
  if (contract && (contract.id !== routeContractId || contract.customerPartnerId !== routeCustomerId)) return "discard";
  if (canLinkInstallations === false) return "discard";
  if (!contract || canLinkInstallations === undefined) return "wait";
  return "open";
}

export function useContractInstallationIntent(state: InstallationIntentState, onOpen: () => void) {
  const search = useSearch();
  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(INTENT_PARAM)) return;
    const decision = url.searchParams.get(INTENT_PARAM) === "1"
      ? installationIntentDecision(state) : "discard";
    if (decision === "wait") return;
    // Consume BEFORE opening/redirecting; preserve history state and other params.
    // Refetch, StrictMode, cancellation, reload and Back cannot replay the intent.
    url.searchParams.delete(INTENT_PARAM);
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
    if (decision === "open") onOpen();
  }, [state.routeCustomerId, state.routeContractId, state.contract, state.canLinkInstallations, state.failed, onOpen, search]);
}
